import { useThree } from '@react-three/fiber'
import { useAnimations } from "@react-three/drei";
import {useEffect, useState} from 'react'
import { RigidBody, CuboidCollider } from '@react-three/rapier';
import music from '../../public/sound/shepard_tone_seamless.mp3'
import evilLaugh from '../../public/sound/shining.mp3'
import useAudioStore from "../stores/useAudioStore.js";
import { MeshBasicMaterial, ShaderMaterial } from 'three';
import * as THREE from 'three';

import useGame from '../stores/useGame.js'

export default function Hotel(props) {

  //Zustand
  const startShepardAudio = useAudioStore((state)=>{return state.startShepardAudio})

  // Shining Laugh
  const sound = new Audio(music);



  let setEscape = useGame((state)=> state.setEscape)

    let doorMesh1 = null;
    props.hotel.scene.traverse((child) => {
      if (child.name === 'Portal1') {
          doorMesh1 = child;
      }
    });

    let doorMesh2 = null;
    props.hotel.scene.traverse((child) => {
      if (child.name === 'Portal2') {
          doorMesh2 = child;
      }
    });

    let doorMesh3 = null;
    props.hotel.scene.traverse((child) => {
      if (child.name === 'Portal3') {
          doorMesh3 = child;
      }
    });

const portalMaterial = new MeshBasicMaterial({
  color: '#f5f5f5'
})

doorMesh1.material = portalMaterial
doorMesh2.material = portalMaterial
doorMesh3.material = portalMaterial

    const {scene} = useThree()

  function fadeIn(sound) {
    let timer
    if(sound.volume < 0.9985) {
      sound.volume += 0.0015
      timer = setTimeout(()=>{fadeIn(sound)}, 5)
    }
  }

    // DoorTrigger Fog adjustment
    function doorTrigger() {
      scene.fog.far = 50;
    }

    // move to audiostore
  function playEvilLaugh(evilLaugh) {
    const sound = new Audio(evilLaugh);
    sound.volume = 0.4
    sound.play();
  }

    return <>

    {/* trimesh rigidbody for hotel hallway */}
    <RigidBody type="fixed" colliders="trimesh">
        <primitive scale={4} position={[5,-20,-5]} object={ props.hotel.scene } />
    </RigidBody>

    {/* door sensor */}
    <CuboidCollider
      args={[10, 10, 1]}
      // position={[152,-15,70]}
      position={[154,-12,71]}
      sensor
      onIntersectionEnter={() => {
        setEscape()
        if(sound.paused) {
          doorTrigger()
          startShepardAudio()
          playEvilLaugh(evilLaugh)
        }
      }}
    />
    </>
}
